<template>
  <div class="wrap-black text-center">
    <div class="container">
      <p class="xs-pb-30 text-larger">
        Thank You For Signing Up With CLEX!
        <br />
        You Are Now One Step Away From Starting Your Learning Experience.
      </p>
      <router-link class="btn-pub btn-pub-primary btn-pub-borderless" :to="{name: 'subject-shelf'}">Continue To Dashboard</router-link>

      <p class="xs-pt-50">
        We've sent you an email confirmation for your account,<br />
        if you haven't received it in your inbox <router-link :to="{name: 'contact-us'}"><strong>please let use know</strong></router-link>!
      </p>
      <p>
        Our service is free and we look forward to hearing any <router-link :to="{name: 'contact-us'}"><strong>feedback</strong></router-link> you have.
      </p>
    </div>
  </div>
</template>


<script>
  import _ from 'underscore'
  import InnerBanner from '../shared/controls/InnerBanner'
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'


export default {
    components: {
      InnerBanner,
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  p { font-size: 18px; line-height: 24px; }
  p a {color:#FFFFFF;}
    p.text-larger { font-size: 20px; }
  .container {max-width:700px;margin:0px auto;}

  @media (max-width: 992px) {
    .container { max-width: 100%;}
    .btn-pub { font-size:1.8rem;}
  }
  @media (max-width: 767px) {
    .wrap-black { padding: 40px 20px; }
  }
</style>



// WEBPACK FOOTER //
// Success.vue?7302a822